<template>
  <el-switch
    :active-value="activeValue"
    :inactive-value="inactiveValue"
    v-bind="$attrs"
    v-model="switchValue"
  >
  </el-switch>
</template>
<script setup>
import { defineProps, onMounted, watch, ref } from "vue";
const props = defineProps({
  /** v-model选中项绑定值*/
  modelValue: {
    type: [String, Boolean, Number],
    default: null,
    required: true,
  },
  /** switch 状态为 on 时的值*/
  activeValue: {
    type: [String, Boolean, Number],
    default: 0,
    required: true,
  },
  /** switch的状态为 off 时的值*/
  inactiveValue: {
    type: [String, Boolean, Number],
    default: 1,
  },
});
const switchValue = ref(0);

onMounted(() => {
  if (typeof props.modelValue === "object") {
    switchValue.value = props.modelValue.value;
  } else {
    switchValue.value = props.modelValue;
  }
});
watch(
  () => props.modelValue,
  () => {
    if (typeof props.modelValue === "object") {
      switchValue.value = props.modelValue.value;
    } else {
      switchValue.value = props.modelValue;
    }
  }
);
</script>
<style scoped></style>
